import { SET_ORGANIZATION, RESET_ORGANIZATION } from "../../actions/Organization/actionConstants";

const organization = (state = [], action) => {
	switch (action.type) {
		case SET_ORGANIZATION:
			console.log("ininin");
			return action.data;
		case RESET_ORGANIZATION:
			return {};
		default:
			return state;
	}
};

export default organization;
